import {HttpParams} from '@angular/common/http';

export class QueryModel {
    isSortDesc: boolean;
    page: number;
    pageSize: number;
    sortBy: string;
}
export class PublicationQueryModel {
    isSortDesc: boolean;
    page: number;
    pageSize: number;
    sortBy: string;
    aplicantId?:number;
    stateId?:number;
    isReminderSent:boolean;
    searchText:string;
    years:number[]=[];

}
export class HistoryQueryModel {
    isSortDesc: boolean;
    page: number;
    pageSize: number;
    sortBy: string;
    searchText:string;
    years:number[]=[];
}



// WEBPACK FOOTER //
// ./src/app/+app-custom/models/query.model.ts